module.exports = __webpack_public_path__ + "img/img3.3b17cce2.png";